<template>
    <v-select
        v-model="opcionElegida"
        variant="solo"
        :items="opcionesBusqueda"
        item-title="nombre"
        return-object
        :rules="obligatorio"
        :loading="cargandoSelect"
        label="Buscar por"
        required
        />
    <v-text-field
        v-model="datoProfesional"
        :rules="obligatorioAlfanumerico"
        label="Dato del profesional"
        required
        variant="solo"
    ></v-text-field>
    <v-btn
        @click="buscarProfesional"
        :disabled="!datoProfesional"
        id="boton-verde"
        :loading="cargando"
    >
        Buscar
    </v-btn>
    <ClosableAlert
        v-if="alert"
        :type="alertType"
        :key="alertKey"
        :texto="mensaje"
        titulo="Profesional"
    ></ClosableAlert>
</template>
<style src="../assets/general.css"></style>
<script>
    import ProfesionalService from '@/api/ProfesionalService';
    import ClosableAlert from './ClosableAlert.vue';
    import Profesional from '../interfaces/adminInterfaces';
    import { obligatorioAlfanumerico } from '@/_helpers/rules';

    const profesionalService = new ProfesionalService();

    export default {
        components: {
            ClosableAlert
        },
        mounted(){
            this.getOpcionesBusqueda()
        },
        data() {
            return {
                profesional : Profesional,
                datoProfesional: '',
                cargando: false,
                cargandoSelect: false,
                alert: false,
                alertType: '',
                alertKey: 0,
                mensaje: '',
                opcionesBusqueda: [],
                opcionElegida: {}
            }
        },
        methods:{
            async buscarProfesional(){
                this.cargando = true;
                const response =  await profesionalService.getProfesional(this.datoProfesional,this.opcionElegida.valor);
                if(response && response.status == 200){
                    this.profesional = response.data;
                    this.alertType = 'success';
                    this.mensaje = 'Profesional existente: ' + this.profesional.nombres + ' ' + this.profesional.apellidos + ' ; CUIT \n : ' + this.profesional.cuit + ' ; MP: ' + this.profesional.matriculaProvincial + ' ; MN: ' + this.profesional.matriculaNacional ;
                }
                else{
                    this.alertType = 'error';
                    this.mensaje = 'Error al buscar profesional';
                }
                this.alert = true;
                this.alertKey += 1;
                this.cargando = false;
            },
            async getOpcionesBusqueda(){
                this.cargandoSelect = true;
                const response =  await profesionalService.getOpcionesBusqueda();
                if(response && response.status == 200){
                    this.opcionesBusqueda = response.data;
                    this.opcionElegida = response.data[0];
                }
                else{
                    this.alertType = 'error';
                    this.mensaje = response.error;
                    this.alert = true;
                    this.alertKey += 1;
                }
                this.cargandoSelect = false;
            }
        }
    }
</script>